import request from '@/router/axios';

export const getList = (params) => {
  return request({
    url: '/api/produce/device-inspection-error/select/page',
    method: 'post',
    params
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/produce/device-inspection-error/select/id',
    method: 'get',
    params: { id }
  })
}

export const syncLatest = (params) => {
  return request({
    url: '/api/produce/device-inspection-error/sync',
    method: 'post',
    params
  })
}

export const exportExcel = (params) => {
  return request({
    url: '/api/produce/device-inspection-error/export/excel',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export const add = () => Promise.reject(new Error('当前页面不支持新增'))
export const update = () => Promise.reject(new Error('当前页面不支持编辑'))
export const remove = () => Promise.reject(new Error('当前页面不支持删除'))
